export default __webpack_public_path__ + "static/media/CNo.72-6.1e993bc5.jpg";